<template>
    <el-collapse>
        <log-table v-if="log.length > 0" :table="log"/>
        <el-collapse-item v-for="(item, i) in tables" :key="i" :name="i">
            <span slot="title" class="collapse-title">{{ item.title }}</span>
            <modeler-table-params class="modeler-table" :table="item.table"/>
        </el-collapse-item>
    </el-collapse>
</template>

<script>
  import ModelerTableParams from "./ModelerTableParams";
  import LogTable from "../_reports/LogTable";
  export default {
    name: "ModelerTables",
    components: {LogTable, ModelerTableParams},
    props: {
      tables: Array[Object],
      log: {
        type: Array,
        default: () => ([])
      },
    }
  }
</script>

<style scoped>
    .modeler-table {
        /*margin-right causes table to continuously expand*/
        width: calc(100% - 1em);
    }
</style>
